import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';

import { enterFullScreen, exitFullScreen } from 'actions/screen';
import { closeSidebar } from 'actions/sidebar';
import { logoutUser } from 'actions/user';

import PlayerStats from 'components/PlayerStats';
import Qualities from 'components/SidebarQualities';
import Config from 'configuration';

import NavItem from './NavItem';

class ResponsiveSidebar extends Component {
  closeSidebar = () => {
    const { dispatch } = this.props;
    dispatch(closeSidebar());
  }

  logoutUser = () => {
    const { dispatch, history } = this.props;
    return dispatch(logoutUser(history));
  }

  makeHandler = location => () => this.selectTab(location)

  /**
   * Move to a new tab.
   */
  selectTab = (location) => {
    const { dispatch, history } = this.props;
    // Close the sidebar
    dispatch(closeSidebar());
    // Take us to the new location
    history.push(location);
  }

  toggleFullScreen = () => {
    const { dispatch, screen } = this.props;
    dispatch(closeSidebar());
    if (screen.full) {
      return dispatch(exitFullScreen());
    }
    return dispatch(enterFullScreen());
  }

  render() {
    const { isOpen, screen, name } = this.props;
    return (
      <div>
        <div
          className={classnames(
            'js-sidemenu-overlay sidemenu-overlay',
            isOpen && 'sidemenu-overlay--open',
          )}
          onClick={this.closeSidebar}
        />
        <div
          className={classnames(
            'sidemenu sidemenu--left',
            isOpen && 'sidemenu--open',
          )}
          aria-hidden={!isOpen}
        >
          <div>
            <PlayerStats />
            <Qualities />
            <nav className="sidemenu__nav" aria-hidden="true">
              <ul className="items">
                <NavItem fl icon="myself" onClick={this.makeHandler(`/profile/${name}`)}>Your profile</NavItem>
                <NavItem icon="user" onClick={this.makeHandler('account')}>Account</NavItem>
                <NavItem fl icon="deck" onClick={this.makeHandler('fate')}>Fate</NavItem>
                <NavItem icon="star" onClick={this.makeHandler('plans')}>Plans</NavItem>
                <NavItem icon="question-circle" onClick={this.makeHandler('help')}>Help</NavItem>
                <NavItem
                  icon={screen.full ? 'compress' : 'expand'}
                  onClick={this.toggleFullScreen}
                >
                  {screen.full ? 'Exit fullscreen' : 'Go fullscreen'}
                </NavItem>
                <NavItem icon="sign-out" onClick={this.logoutUser}>Log out</NavItem>
              </ul>
            </nav>
            <div className="sidemenu__version-number">
              Version
              {' '}
              {Config.version}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResponsiveSidebar.displayName = 'ResponsiveSidebar';

ResponsiveSidebar.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  name: PropTypes.string,
  screen: PropTypes.shape({
    full: PropTypes.bool.isRequired,
  }).isRequired,
};

ResponsiveSidebar.defaultProps = {
  name: undefined,
};

const mapStateToProps = ({
  screen,
  sidebar,
  myself: { character: { name } },
}) => ({
  ...sidebar,
  screen,
  name,
});

export default withRouter(connect(mapStateToProps)(ResponsiveSidebar));